<div class="sub-header" *ngIf="!preventShoping">
  <div class="resident-info-container sub-header-part">
    <div
      class="resident-base-info-container"
      *ngIf="customer && selectedResident?.id">
      <div class="flex gap-16px" style="flex: 1">
        <div class="flex gap-16px" style="flex: 1">
          <div class="flex align-center gap-8px">
            <mat-icon
              svgIcon="back-icon"
              class="arrow-icon"
              [class.hidden-arrow]="isPreviousArrowHidden"
              (click)="moveToResident('previous')"></mat-icon>
            <app-profile-avatar
              [name]="selectedResident.getName()"
              [color]="selectedResident.color"
              [size]="100"
              [shouldAnimate]="true"
              [image]="selectedResidentImage"
              class="resident-avatar"
              [class.washy]="shouldBeWashy"></app-profile-avatar>
          </div>
          <div class="info-actions-container">
            <div
              class="resident-base-info"
              [ngClass]="{
                'with-room-or-iban':
                  selectedResident?.roomNumber || selectedResident?.hasIBAN,
                'without-room-or-iban': !(
                  selectedResident?.roomNumber || selectedResident?.hasIBAN
                )
              }">
              <div
                [class.washy]="shouldBeWashy"
                style="display: flex; align-items: center; height: 20px"
                *ngIf="
                  selectedResident?.roomNumber || selectedResident?.hasIBAN
                ">
                <p class="room" *ngIf="selectedResident?.roomNumber">
                  ZIMMER {{ selectedResident?.roomNumber }}
                </p>
                <app-sepa-check
                  [white]="true"
                  *ngIf="selectedResident?.hasIBAN"></app-sepa-check>
              </div>
              <span style="display: flex; align-items: center">
                <p class="name" [class.washy]="shouldBeWashy">
                  <span *ngIf="selectedDepartment?.isB2B">
                    {{ selectedDepartment?.name }} (B2B)
                  </span>
                  <span *ngIf="!selectedDepartment?.isB2B">
                    {{ selectedResident.fname }}
                    <br class="resident-name-break" />
                    {{ selectedResident.lname }}
                  </span>
                </p>
                <app-inactive-resident-alert
                  style="margin-left: 15px"
                  *ngIf="selectedResident?.active === 0"
                  [resident]="selectedResident"></app-inactive-resident-alert>
                <app-no-connext-account-id-error
                  *ngIf="
                    selectedResident | hasNoValidPaymentMethod
                  "></app-no-connext-account-id-error>
              </span>
            </div>
            <div class="resident-actions" [class.washy]="shouldBeWashy">
              <div
                class="action"
                [class.active]="isFavouritesActive"
                (click)="navigateToFavourites()">
                <mat-icon svgIcon="heart-icon" class="action-icon"></mat-icon>
                <p class="action-text text-trim">Favoriten</p>
              </div>
              <div
                class="action"
                [class.active]="isLastOrderedActive"
                (click)="navigateToLastOrdered()">
                <mat-icon svgIcon="recent-icon" class="recent-icon"></mat-icon>
                <p class="action-text text-trim">
                  {{ 'webHeader.lastOrdered' | translate }}
                </p>
              </div>
              <div class="action" (click)="openBedarfslisteDialog()">
                <mat-icon
                  svgIcon="list-of-needs-icon"
                  class="list-of-needs-icon"></mat-icon>
                <p class="action-text text-trim">Bedarfsliste erfassen</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex align-center gap-24px">
        <app-resident-note
          [shouldBeWashy]="shouldBeWashy"
          class="resident-note"
          *ngIf="selectedResident?.internalNote"
          [resident]="selectedResident"></app-resident-note>
        <div class="flex align-center" style="height: 100%">
          <div class="cart-section" [class.washy]="shouldBeWashy">
            <div class="cart-total">
              <app-resident-budget
                [resident]="selectedResident"
                theme="light"
                *ngIf="
                  selectedResident && !selectedDepartment?.isB2B
                "></app-resident-budget>
              <p class="open-cart-text" (click)="openDialog()">
                In die Tüte
                <br />
                schauen:
              </p>
              <p style="font-size: 20px; font-weight: 700; text-align: right">
                € {{ residentTotalValue | number: '1.2-2' }}
              </p>
            </div>
            <div (click)="openDialog()" class="bag" style="cursor: pointer">
              <mat-icon svgIcon="bag-icon" class="bag-icon"></mat-icon>
              <div class="items-count-container">
                <p
                  class="items-count text-trim"
                  [ngStyle]="{
                    '--digitCount': residentItemsCountValue.toString().length
                  }">
                  {{ residentItemsCountValue }}
                </p>
              </div>
            </div>
          </div>
          <mat-icon
            svgIcon="back-icon"
            class="forward arrow-icon"
            [class.hidden-arrow]="isNextArrowHidden"
            (click)="moveToResident('next')"></mat-icon>
        </div>
      </div>
    </div>
    <div class="no-resident-text" *ngIf="customer && !selectedResident?.id">
      {{
        selectedDepartment?.departmentId
          ? 'Für den ausgewählten Wohnbereich sind aktuell noch keine Bewohner:innen angelegt.'
          : 'Bitte wählen Sie zunächst Wohnbereich und Bewohner:in aus, für wen Sie einkaufen möchten'
      }}
    </div>
    <div
      *ngIf="!customer"
      style="width: 100%"
      class="flex justify-center align-center">
      <mat-progress-spinner
        mode="indeterminate"
        style="width: 90px"></mat-progress-spinner>
    </div>
  </div>
  <div
    class="sub-header-part order-button"
    (click)="navigateToOrderOverview()"
    *ngIf="customer">
    <mat-icon svgIcon="order-icon" class="order-icon"></mat-icon>
    <span>
      Zur
      <br />
      Kasse
    </span>
  </div>
</div>
<app-no-deparment-or-order *ngIf="preventShoping"></app-no-deparment-or-order>
